import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ContactSupportService } from 'src/app/services/contact-support.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {

  frmSupport: UntypedFormGroup;
  submitted: boolean = false;
  companyCode: string = localStorage.getItem('company_code');
  showBackButton: boolean = false;
  selectedEmailSendTo: number | null = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private contactSupportService: ContactSupportService,
    private route: ActivatedRoute,
    public location: Location
  ) { }

  ngOnInit(): void {
    this.frmSupport = this.formBuilder.group({
      comment: ['', Validators.required]
    });
    this.showBackButton = !!this.route.snapshot.data?.['showBackButton'];
  }

  get fSupport() {
    return this.frmSupport.controls;
  }

  get selectedSupportTypeLabel(): string {
    if (this.selectedEmailSendTo === 2) {
      return 'Technical Support';
    }
    if (this.selectedEmailSendTo === 1) {
      return 'Customer Support';
    }
    return '';
  }

  // Customer portal (eCert): choose the recipient first, then show the comment box.
  selectSupportType(emailSendTo: number) {
    this.selectedEmailSendTo = emailSendTo;
  }

  changeSupportType() {
    this.selectedEmailSendTo = null;
    this.submitted = false;
    this.frmSupport.reset();
  }

  // Header "Back" button (customer portal only): if a recipient has already been
  // chosen, go back to the choice screen first instead of navigating away.
  onBackClick() {
    if (this.selectedEmailSendTo !== null) {
      this.changeSupportType();
      return;
    }
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    if (this.frmSupport.invalid) {
      this.frmSupport.markAllAsTouched();
      return;
    }

    // Recipient was already chosen via selectSupportType().
    this.sendSupportRequest(this.selectedEmailSendTo);
  }

  private sendSupportRequest(emailSendTo: number) {
    this.contactSupportService.sendContactSupport({
      companycode: this.companyCode,
      Comment: this.frmSupport.value.comment,
      EmailSendTo: emailSendTo
    }).subscribe(
      (res) => {
        if (res && res['message']) {
          alert(res['message']);
        } else {
          alert('Your request has been submitted successfully.');
        }
        this.submitted = false;
        this.frmSupport.reset();
        this.selectedEmailSendTo = null;
      },
      (error) => {
        console.log(error);
        alert('Something went wrong while submitting your request. Please try again.');
      }
    );
  }
}
